import { BaseComponent } from '../../../common/component/base.component';
import { FormProperty } from '../../../common/entity/form/formProperty';
import { Directive } from '@angular/core';

@Directive()
export class CustomerBaseComponent extends BaseComponent {
  public properties: FormProperty[] = [];
  public menuItemName = 'pdap_integration';
}
